import renderDateField from 'components/DateField/reduxFormDateField';
import renderField from 'components/Field/reduxForm';
import moment from 'utils/moment';
import {
  getRequiredFn,
  getValidateMaxDateFn,
  isValidDate,
  validateSnils,
} from 'utils/reduxForm/validations';
import * as parsers from '../../../../utils/reduxForm/parsers';
import { isObject } from 'lodash';
const required = getRequiredFn();
const availableDate = moment().endOf('day');

export const STEP_INITIAL = 'initial';
export const STEP_CONFIRM = 'confirm';
export const STEP_DONE = 'done';

export const QUALIFIED_APPLICATION_FORM = 'qualifiedSignApplicationForm';

export const statusesData = {
  IP: 'Индивидуальный предприниматель',
  ORGANIZATION: 'Представитель организации',
  ADVOCATE: 'Адвокат',
  NOTARY: 'Нотариус',
};

export const ORGANIZATION = 'ORGANIZATION';

export const personalDataQSA = Object.freeze({
  dateOfBirth: {
    name: 'dateOfBirth',
    placeholder: 'Дата рождения',
    label: 'Дата рождения',
    component: renderDateField,
    maxDate: availableDate,
    getter: (props) => props.personalInfo.get('data').dateOfBirth,
    parse: parsers.momentParser,
    validate: [required, isValidDate, getValidateMaxDateFn(availableDate)],
    isRequired: true,
  },
  inn: {
    name: 'inn',
    placeholder: 'ИНН',
    label: 'ИНН',
    component: renderField,
    disabled: true,
    getter: (props) => props.user.getIn(['data', 'inn']),
    validate: required,
    isRequired: true,
  },
  departmentCode: {
    name: 'departmentCode',
    placeholder: 'Код подразделения',
    label: 'Код подразделения',
    maxLength: 20,
    component: renderField,
    isVisible: {
      check: (selectedCode) => {
        let code = isObject(selectedCode) ? selectedCode.value : selectedCode;
        return code === '21'; //passport code
      },
      stateField: 'selectedCode',
    },
    getter: (props) => props.personalInfo.get('data').dulUnit,
    validate: required,
    isRequired: true,
  },
  snils: {
    name: 'snils',
    placeholder: 'СНИЛС',
    label: 'СНИЛС',
    component: renderField,
    mask: '111-111-111 11',
    autoComplete: 'off',
    validate: [required, validateSnils],
    getter: (props) => props.personalInfo.get('data').snils,
    isRequired: true,
  },
});
